import type { ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material'
import { buttonColorOptions } from '../MuiButton/constants'

declare module '@mui/material/IconButton' {
  interface IconButtonOwnProps {
    variant?: 'outlined'
  }
}

const getVariants: (theme: Theme) => ComponentsVariants['MuiButton'] = (theme) => [
  ...buttonColorOptions.map((option) => ({
    props: { disabled: true, color: option },
    style: {
      '&.Mui-disabled': {
        color: theme.palette[option].main,
        opacity: 0.5,
      },
    },
  })),
  {
    props: { disabled: true, color: 'inherit' },
    style: {
      '&.Mui-disabled': {
        color: 'inherit',
        opacity: 0.5,
      },
    },
  },
]

const styleOverrides: ComponentsOverrides<Theme>['MuiIconButton'] = {
  root: ({ theme }) => ({
    variants: getVariants(theme),
  }),
  sizeLarge: {
    padding: '0.625rem',
  },
  sizeMedium: {
    padding: '0.375rem',
  },
  sizeSmall: {
    padding: '0.375rem',
  },
}

const variants: ComponentsVariants['MuiIconButton'] = [
  {
    props: { variant: 'outlined' },
    style: {
      border: '0.0625rem solid',
      borderColor: 'color-mix(in srgb, currentColor 40%, transparent)',
      borderRadius: '0.5rem',
      '& .MuiTouchRipple-child': {
        borderRadius: '0.5rem !important',
      },
      '&:hover': {
        backgroundColor: 'color-mix(in srgb, currentColor 4%, transparent)',
      },
      '&:disabled': {
        opacity: 0.5,
      },
    },
  },
]

const MuiIconButton = {
  styleOverrides,
  variants,
}

export default MuiIconButton
